/**
 * @format
 * @flow
 */

import React, { Component } from 'react'
import { Container } from 'react-bootstrap'
import { Link } from "react-router-dom"
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { setFlushCart } from '../actions/cartAction'
import formatRelative from 'date-fns/formatRelative';
import { getDateFnsLocale } from '../localize/i18n'
import { computeDiscount, formatCurrency } from './Utils';
import FooterBar from './FooterBar'

import ProductCartRow from './ProductCartRow'

import '../styles/Confirm.scss';

type Props = {
  cart: object,
  customerDetails: object,
  setFlushCart: Function,
  settings: object,
  t: Function,
}

type State = {
  showDetails: boolean,
}

class Confirm extends Component<Props, State> {
  constructor(props) {
    super(props);
    props.setFlushCart();

    this.state = {
      showDetails: false,
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const { t } = this.props
    const rawPickupDate = this.props.cart.pickupDate;
    const pickupDate = rawPickupDate ? new Date(rawPickupDate) : null;
    const hasValidPickupDate = pickupDate !== null && !isNaN(pickupDate.getTime());
    return (
      <Container className="container" id="confirm-page">
        <h1>{t('confirm.title', { name: this.props.customerDetails.firstName })}</h1>

        <p>
          {t('confirm.text1')}<br />
          {t('confirm.text2')}
        </p>

        <div className="confirm-recap">
          <div className="confirm-recap-header"><h4>{t('confirm.recap')}</h4></div>
          <div className={`confirm-recap-toggle ${this.state.showDetails ? 'expanded' : ''}`} onClick={() => this.setState(old => ({ showDetails: !old.showDetails }))}>
            <div>{t('confirm.showDetails')}</div>
            <div className="confirm-recap-price">
              {!this.state.showDetails &&
                formatCurrency(this.props.cart.totalConfirm, this.props.settings.currencySymbol)
              }
            </div>
          </div>
          <div className={`cart-product-container ${this.state.showDetails ? '' : 'hide'}`}>
            {this.props.cart.products.map((product, index) =>
              <ProductCartRow product={product} key={index} index={index} onClick={() => null} editable={false} />
            )}
            <hr />
            <div>
              {this.props.cart.totalConfirm.toFixed(2) !== this.props.cart.subtotal.toFixed(2) && (
                <div className="cart-product-total">
                  <span>{t('confirm.subtotal')}</span>
                  <span>{formatCurrency(this.props.cart.subtotal, this.props.settings.currencySymbol)}</span>
                </div>
              )}
              {this.props.cart.discount > 0 && this.props.cart.subtotal !== this.props.cart.total && (
                <div className="cart-product-total">
                  <span>{t(this.props.cart.type === 1 ? 'restaurant.discountTakeaway' : this.props.cart.type === 4 ? 'restaurant.discountDelivery' : 'restaurant.discount', { discount: this.props.cart.discount })}</span>
                  <span>-{formatCurrency(this.props.cart.subtotal - this.props.cart.total, this.props.settings.currencySymbol)}</span>
                </div>
              )}
              {this.props.cart.coupon && this.props.cart.coupon?.discountType === 'percent' && (
                <div className="cart-product-total">
                  <div>{t('restaurant.couponPercent', { percent: this.props.cart.coupon.discountPercent })}</div>
                  <div>-{formatCurrency(computeDiscount(this.props.cart.total, this.props.cart.coupon.discountPercent, false), this.props.settings.currencySymbol)}</div>
                </div>
              )}

              {this.props.cart.coupon && this.props.cart.coupon?.discountType === 'price' && (
                <div className="cart-product-total">
                  <div>{t('restaurant.couponPrice', { price: formatCurrency(this.props.cart.coupon.discountPrice, this.props.settings.currencySymbol) })}</div>
                  <div>-{formatCurrency(this.props.cart.coupon.discountPrice, this.props.settings.currencySymbol)}</div>
                </div>
              )}

              {this.props.cart.coupon && this.props.cart.coupon?.discountType === 'product' && (
                <div className="cart-product-total">
                  <div>{t('restaurant.couponProduct', { product: this.props.cart.coupon.discountProduct })}</div>
                </div>
              )}

              {this.props.cart.feeTotal > 0 &&
                <div className="cart-product-total">
                  <span>{t('checkout.deliveryFee')}</span>
                  <span>{formatCurrency(this.props.cart.feeTotal, this.props.settings.currencySymbol)}</span>
                </div>
              }
              <div className="cart-product-total big">
                <span>{t('confirm.total')}</span>
                <span>{formatCurrency(this.props.cart.totalConfirm, this.props.settings.currencySymbol)}</span>
              </div>
            </div>
          </div>
        </div>

        {this.props.cart.orderType === 1 ? (
          <div className="confirm-address">
            <div><h4>{t('confirm.pickupAddress')}</h4></div>
            <div>
              {this.props.cart.restoInformations.name}
            </div>
            <div>
              {this.props.cart.restoInformations.address}
            </div>
            <div>{this.props.cart.restoInformations.city} - {this.props.cart.restoInformations.postalCode}</div>
          </div>
        ) : this.props.cart.orderType === 4 ? (
          <div className="confirm-address">
            <div><h4>{t('confirm.deliveryAddress')}</h4></div>
            <div>
              {this.props.customerDetails.address}
            </div>
            <div>
              {this.props.customerDetails.postal.postalCity} {this.props.customerDetails.postal.postalCode}
            </div>
            <div>
              {this.props.customerDetails.addressComplement}
            </div>
          </div>
        ) : ''
        }

        {hasValidPickupDate && (
        <div className="confirm-address">
          {this.props.cart.orderType === 1 ? (
            <div><h4>{t('checkout.pickupTime')}</h4></div>
          ) : this.props.cart.orderType === 4 ? (
            <div><h4>{t('checkout.deliveryTime')}</h4></div>
          ) : ''}
          <div className="capitalize">
            {formatRelative(pickupDate, new Date(), { locale: getDateFnsLocale() })}
          </div>
        </div>
        )}

        <div className="confirm-email">{t('confirm.emailSent', { email: this.props.customerDetails.email })}</div>

        <div className="confirm-recap">
          <div id="question-recap-title"><h4>{t('confirm.question')}</h4></div>
          <div>{t('confirm.callRestaurant', { phone: this.props.cart.restoInformations.phone })}</div>
        </div>


        <div className="back-to-home">
          <Link
            to={`/${this.props.match.params.id}`}
          >
            <div style={{ textAlign: 'center', fontSize: '16px' }}>
              {t('confirm.backHome')}
          </div>
          </Link>
        </div>

        <FooterBar orderType={this.state.orderType} />
      </Container >
    )
  }
}


const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    customerDetails: state.customerDetails,
    settings: state.settings,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setFlushCart: () => dispatch(setFlushCart())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Confirm));